import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function Shop() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    const body = new URLSearchParams();
    body.append("email", email.trim());

    try {
      await fetch("https://readdy.ai/api/form/d72a0hkjuufb4jdbl0hg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <main className="bg-[#F4F3F0] min-h-screen flex flex-col">
      <Navbar />

      {/* Main Coming Soon */}
      <section className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-2xl w-full text-center">

          {/* Eyebrow */}
          <span className="inline-block text-[#6B9E8A] text-xs font-semibold uppercase tracking-[0.22em] mb-8">
            The Shop
          </span>

          {/* Headline */}
          <h1 className="font-serif text-5xl lg:text-6xl text-[#1A1A1A] leading-[1.1] mb-6">
            Something is<br />being made.
          </h1>

          <p className="text-[#888] text-base leading-relaxed max-w-md mx-auto mb-12">
            We&apos;re putting together a small collection of tools for disciplined readers. 
            Journals, accessories, things worth owning. Nothing is rushed.
          </p>

          {/* Divider dot */}
          <div className="flex items-center justify-center gap-2 mb-12">
            <span className="w-1 h-1 rounded-full bg-[#3A5544]" />
            <span className="w-1.5 h-1.5 rounded-full bg-[#3A5544]" />
            <span className="w-1 h-1 rounded-full bg-[#3A5544]" />
          </div>

          {/* Notify form */}
          {!submitted ? (
            <div className="bg-white rounded-lg p-8 max-w-md mx-auto">
              <p className="text-[#1A1A1A] text-sm font-medium mb-1">Get notified when we launch</p>
              <p className="text-[#999] text-xs mb-5">No spam. One email when it&apos;s ready.</p>

              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 border border-[#E0DED9] rounded px-4 py-2.5 text-sm text-[#1A1A1A] placeholder-[#BBB] outline-none focus:border-[#3A5544] transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap bg-[#3A5544] text-white text-sm font-medium px-6 py-2.5 rounded hover:bg-[#2D4238] transition-colors cursor-pointer"
                >
                  Notify me
                </button>
              </form>

              {error && (
                <p className="text-red-500 text-xs mt-3">{error}</p>
              )}
            </div>
          ) : (
            <div className="bg-white rounded-lg p-8 max-w-md mx-auto flex flex-col items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EAF2EE]">
                <i className="ri-check-line text-[#3A5544] text-lg" />
              </div>
              <p className="text-[#1A1A1A] text-sm font-medium">You&apos;re on the list</p>
              <p className="text-[#999] text-xs">We&apos;ll reach out when the shop opens.</p>
            </div>
          )}

          {/* Nudge back to the challenge */}
          <p className="text-[#AAA] text-xs mt-12">
            In the meantime —{" "}
            <Link to="/challenge" className="text-[#3A5544] underline underline-offset-2 hover:text-[#2D4238] transition-colors cursor-pointer">
              start the 30-day challenge
            </Link>
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}
